"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioInput = exports.RadioButton = void 0;
var react_1 = __importDefault(require("react"));
var themes_1 = require("../../../../../../themes");
var icons_1 = require("../../../../../../icons");
var Typo_1 = require("../../../../../Typo");
var utils_1 = require("../../../../utils");
var styled_1 = require("../../../../styled");
var styled_2 = require("./styled");
var invertGreen = themes_1.colors.invertGreen, red = themes_1.colors.red, greyColor40 = themes_1.colors.greyColor40, green = themes_1.colors.green, invertRed = themes_1.colors.invertRed;
var XCircle = icons_1.icons.XCircle, CheckCircle = icons_1.icons.CheckCircle;
var RadioButton = function (_a) {
    var isSelected = _a.isSelected, onClick = _a.onClick, disabled = _a.disabled, invert = _a.invert, S = _a.S, readOnly = _a.readOnly;
    return (react_1.default.createElement(styled_2.StyledRadioInput, { onClick: function (ev) { return onClick && onClick(ev); }, isSelected: isSelected, disabled: disabled, invert: invert, S: S, readOnly: readOnly }, isSelected && react_1.default.createElement(styled_2.StyledRadioInputFill, { invert: invert, S: S })));
};
exports.RadioButton = RadioButton;
var RadioInput = function (_a) {
    var option = _a.option, onClick = _a.onClick, disabled = _a.disabled, invert = _a.invert, value = _a.value, S = _a.S, rightWrongResult = _a.rightWrongResult;
    var isSelected = option.value === (value === null || value === void 0 ? void 0 : value.value);
    var markingCommand = (0, utils_1.getMarkingCommand)({ option: option, isSelected: isSelected }); // returns undefined if option isn't labeled as 'correct' nor selected
    var TYPO_COMP = S
        ? Typo_1.SANS_2
        : Typo_1.SANS_3;
    var genRadioButton = function (options) {
        if (options === void 0) { options = {}; }
        return (react_1.default.createElement(exports.RadioButton, { isSelected: isSelected, invert: invert, S: S, className: 'btn',
            disabled: options.disabled || disabled //because we force disabled if rightWrongResult exists & no markingCommand exists against this option i.e, it neither has to be marked right nor wrong
         }));
    };
    var genCheckCircle = function () { return (react_1.default.createElement(CheckCircle, { size: S ? 21 : 24.5, color: invert ? invertGreen : green, style: {
            margin: '-5px -1.5px -5px -3px',
            flexShrink: 0
        } })); };
    var genXCircle = function () { return (react_1.default.createElement(XCircle, { size: S ? 21 : 24.5, color: invert ? invertRed : red, style: {
            margin: '-5px -1.5px -5px -3px',
            flexShrink: 0
        } })); };
    return (react_1.default.createElement(styled_1.StyledOption, { disabled: disabled, rightWrongResult: rightWrongResult, isSelected: isSelected, invert: invert, S: S, onClick: function () { return !rightWrongResult && !disabled && onClick(option); } },
        rightWrongResult
            ? ["markCorrect", "revealCorrect"].includes(markingCommand)
                ? genCheckCircle()
                : markingCommand === 'markWrong'
                    ? genXCircle()
                    : genRadioButton({ disabled: true }) //else rightWrongResult has come in, but this doesnt have to be marked right or wrong
            : genRadioButton() // rightWrongResult as not come in. so gen normal radio button
    ,
        react_1.default.createElement(TYPO_COMP, { bold: rightWrongResult && isSelected, color: disabled && greyColor40, invert: invert }, option.display)));
};
exports.RadioInput = RadioInput;
